import { render } from "./z-pagination.vue?vue&type=template&id=5b6cd6aa"
import script from "./z-pagination.vue?vue&type=script&lang=js"
export * from "./z-pagination.vue?vue&type=script&lang=js"

import "./z-pagination.vue?vue&type=style&index=0&id=5b6cd6aa&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__